var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.547594 1.13964L0.326625 1.36057C0.180188 1.50701 0.180188 1.74445 0.326625 1.89092L6.43578 8.00011L0.326625 14.1093C0.180188 14.2557 0.180188 14.4932 0.326625 14.6396L0.547594 14.8606C0.694031 15.007 0.931469 15.007 1.07791 14.8606L7.67325 8.26526C7.81969 8.11882 7.81969 7.88139 7.67325 7.73492L1.07791 1.13964C0.931469 0.993168 0.694031 0.993168 0.547594 1.13964Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.b3f24c25bef047b7648c6fd377ec2cb9.svg";
export { ForwardRef as ReactComponent };